import React from 'react';
import { Modal } from 'antd';
import Item from './Item';
import Icon from '../Icon';
import { bodyScrollFix } from '../../utils';

export default ({
  visible,
  onOk,
  initialItem,
  onAddToCart,
  offerId,
  wrapClassName = 'order',
  ...rest
}) => {
  return (
    <Modal
      title={null}
      footer={null}
      open={visible}
      width="100%"
      closeIcon={<Icon name="close" />}
      centered
      destroyOnClose
      wrapClassName={wrapClassName}
      {...rest}
      afterClose={bodyScrollFix}
    >
      <Item
        initialItem={initialItem}
        addToCart={onAddToCart}
        offerId={offerId}
      />
    </Modal>
  );
};
